import Api from "./Api";
import Csrf from "./Csrf";

export default {
    
  async income(data) {
    await Csrf.getCookie();

    return Api.post("/income_statistics",data);
  },
    
  async excel(data) {
    await Csrf.getCookie();

    return Api.post("/csv_statistics",data,{'responseType': 'blob'});
  },
	
};